import React, { useState } from "react";
import { Images } from "../Common/Images.jsx";
import CustomSearchableDropdown from "../Common/CustomSearchableDropdown.jsx";
import CustomSearchableCheckboxDropdown from "../Common/CustomSearchableCheckboxDropdown.jsx";

import { PostBookingAnswer_api } from "../WeeklyCalendar/WeeklyCalendarAPI";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler.js"
import AlertPopupModal from "./AlertPopupModal.jsx";
import ErrorPopupModal from "./ErrorPopupModal.jsx";
import { useTranslation } from "react-i18next";
const PostbookingQueModal = ({
    questions = [],
    onSubmit,
    onClose,
    postRequestParams,
    selectedBookingDate
}) => {

    console.log("questions at modal", questions);
    const { t } =  useTranslation("common");
    const [answers, setAnswers] = useState({});
    const [errors, setErrors] = useState({});
    const {
        showAlertPopupModal,
        alertPopupModalData,
        showErrorPopupModal,
        errorPopupModalData,
        setShowAlertPopupModal,
        setShowErrorPopupModal
    } = useApiResponseHandler();
//console.log("Selected Booking Date:", selectedBookingDate);
    const bookingDateValue = selectedBookingDate ? new Date(selectedBookingDate) : null;
    const displayDay = bookingDateValue ? bookingDateValue.getDate() : "";
    // Translate via the app's own dictionary instead of toLocaleString(i18n.language),
    // because the JS Intl engine has no data for Irish ("ga") and silently falls back to
    // English. Derive a stable English month name (e.g. "June") to use as the i18n key.
    const displayMonth = bookingDateValue
        ? t(bookingDateValue.toLocaleString("en-GB", { month: "long" }))
        : "";
    const displayYear = bookingDateValue ? bookingDateValue.getFullYear() : "";
    const hasRequiredQuestion = (questions || []).some(
        (q) => q.IsAnswerRequired === 1
    );

    const handleTextChange = (id, value) => {

        setAnswers(prev => ({
            ...prev,
            [id]: value
        }));

        setErrors(prev => ({
            ...prev,
            [id]: ""
        }));
    };

    const handleRadioChange = (id, value) => {

        setAnswers(prev => ({
            ...prev,
            [id]: value
        }));

        setErrors(prev => ({
            ...prev,
            [id]: ""
        }));
    };

    const handleDropdownChange = (id, value) => {

        setAnswers(prev => ({
            ...prev,
            [id]: value
        }));

        setErrors(prev => ({
            ...prev,
            [id]: ""
        }));
    };

    const validateAnswers = () => {

        let newErrors = {};

        questions.forEach(q => {

            if (q.IsAnswerRequired === 1) {

                const ans = answers[q.Id];

                if (
                    ans === undefined ||
                    ans === "" ||
                    ans === null ||
                    (Array.isArray(ans) && ans.length === 0)
                ) {
                    newErrors[q.Id] = t("this_field_is_required");
                }

            }

        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const submitAnswers = async () => {

        const isValid = validateAnswers();
        if (!isValid) return;

        try {

            const QuestionAnswerList = questions.map((q) => {

                const userAnswer = answers[q.Id];

                let answerText = "";

                // TEXTBOX (TYPE 2)
                if (q.AnswerType === 2) {

                    answerText = userAnswer || "";

                }

                // CHECKBOX (TYPE 4)
                else if (Array.isArray(userAnswer)) {

                    const selectedAnswers = (q.AnswersList || [])
                        .filter(a => userAnswer.includes(a.Id))
                        .map(a => a.Answer);

                    answerText = selectedAnswers.join(",");

                }

                // DROPDOWN / RADIO
                else {

                    const selected = (q.AnswersList || []).find(a => a.Id == userAnswer);

                    answerText = selected ? selected.Answer : "";

                }

                return {
                    QuestionId: q.Id,
                    Answer: answerText,
                    Type: q.AnswerType
                };

            });

            const requestParams = {
                ...postRequestParams,
                QuestionAnswerList: QuestionAnswerList
            };


            console.log("API Request for PostBookingAnswer_api:", requestParams);

            const response = await PostBookingAnswer_api(requestParams);
            //const result = handleResponseCode(response);
            console.log("PostBookingAnswer response", response);

            //if (result.success || (response && result.code === 200)) {
            if (response?.Data?.ResponseCode === 200) {

                if (onSubmit) onSubmit(answers);

            }
            else {
                if (onSubmit) onSubmit(null);
                // close only main modal AFTER error modal state is set

            }

        } catch (error) {

            console.error("PostBookingAnswer API error", error);

        }

    };



    return (
        <>
            <div
                className="modal modalqueans ctm-modalscroll-modal d-block"
                id="newmeetingsModal"
                style={{ background: "rgba(217, 217, 217, 0.59)" }}
            >
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">

                        <div className="modal-body">
                            <div className="ctm-modal-header">
                            {!hasRequiredQuestion && (
                                <div className="close-modal" onClick={onClose}>
                                    <img src={Images.Close} alt="Close" />
                                </div>
                            )}

                            <h5 className="popup-title mb-4">
                                {t("react_postbooking_que_title")}
                            </h5>
                             
                                    <div className="selected-current-date">
                                        <span>{displayDay}</span>
                                        <span>{displayMonth} {displayYear}</span>
                                    </div>
                             <div className="divider-line mt-3"></div> 
                             </div>      
                            <div className="modal-des">
                                <div className="modal-scroll-inner">
                                   <div>
                                    <form>
                                    {(questions || []).map((q) => (

                                        <div key={q.Id} className="form-row">

                                            <label className="popup-inner-title m-0">
                                                {q.Question}
                                            </label>

                                            {/* DROPDOWN */}
                                            {q.AnswerType === 3 && (
                                                <div className="ctm-dropdown-que">
                                                    <CustomSearchableDropdown
                                                        items={q.AnswersList || []}
                                                        value={answers[q.Id] || ""}
                                                        labelKey="Answer"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={`${t("react_postbooking_checkbox_placeholder")}`}
                                                        onChange={(value) =>
                                                            handleDropdownChange(q.Id, value)
                                                        }
                                                         error={!!errors[q.Id]} 
                                                    />
                                                </div>
                                            )}

                                            {/* TEXTBOX */}
                                            {q.AnswerType === 2 && (

                                                <input
                                                    type="text"
                                                    //className={`form-control ${errors[q.Id] ? "error-form" : ""}`}
                                                    className={`form-control 
                                                        ${errors[q.Id] ? "error-form" : ""}
                                                        ${!errors[q.Id] && answers[q.Id] ? "success-validation" : ""}
                                                        `}
                                                    placeholder={t("react_postbooking_textbox_placeholder")}
                                                    autoComplete="off"
                                                    value={answers[q.Id] || ""}
                                                    onChange={(e) =>
                                                        handleTextChange(q.Id, e.target.value)
                                                    }
                                                />

                                            )}

                                            {/* RADIO */}
                                            {q.AnswerType === 1 && (

                                                <CustomSearchableDropdown
                                                    items={q.AnswersList || []}
                                                    value={answers[q.Id] || ""}
                                                    labelKey="Answer"
                                                    valueKey="Id"
                                                    searchable={false}
                                                    placeholder={`${t("react_postbooking_textbox_placeholder")}`}
                                                    onChange={(value) =>
                                                        handleRadioChange(q.Id, value)
                                                    }
                                                     error={!!errors[q.Id]} 
                                                />
                                            )}

                                            {/* CHECKBOX */}
                                            {q.AnswerType === 4 && (

                                                <div className="ctm-dropdown-que multiple-dropdown">

                                                    <CustomSearchableCheckboxDropdown
                                                        items={q.AnswersList || []}
                                                        value={answers[q.Id] || []}
                                                        labelKey="Answer"
                                                        valueKey="Id"
                                                        multiple={true}
                                                        searchable={false}
                                                        placeholder={t("react_postbooking_checkbox_placeholder")}
                                                        onChange={(values) => {

                                                            setAnswers(prev => ({
                                                                ...prev,
                                                                [q.Id]: values
                                                            }));

                                                            setErrors(prev => ({
                                                                ...prev,
                                                                [q.Id]: ""
                                                            }));
                                                        
                                                        }}
                                                        required={q.IsAnswerRequired === 1} 
                                                         error={!!errors[q.Id]}
                                                    />

                                                </div>

                                            )}


                                            {/* ERROR MESSAGE */}
                                            {errors[q.Id] && (

                                                <div className="error-text">
                                                    <img src={Images.ErrorMsg} alt="error" />
                                                    <p>{errors[q.Id]}</p>
                                                </div>

                                            )}

                                        </div>

                                    ))}
                                    </form>
                                    </div>

                                </div>
                            </div>
                               <div className="ctm-modal-footer"> <button
                                        className="main-btn outline-green-btn w-full"
                                        onClick={submitAnswers}
                                    >
                                        {t("confirm")}
                                    </button>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

            {showAlertPopupModal && (
                <AlertPopupModal
                    title={alertPopupModalData.title}
                    message={alertPopupModalData.message}
                    onClose={() => setShowAlertPopupModal(false)}
                />
            )}

            {showErrorPopupModal && (
                <ErrorPopupModal
                    title={errorPopupModalData.title}
                    message={errorPopupModalData.message}
                    onClose={() => setShowErrorPopupModal(false)}
                />
            )}
        </>
    );
};

export default PostbookingQueModal;
